/*
 * QModel dxf export mode enumeration
 */
export enum DxfExportMode {
  Cad3D = 0,
  Cad2D = 1,
}
